const LibMask = {
	phone: (phone) => {
		try {
			// Remove todos os caracteres não numéricos
			phone = phone.replace(/\D/g, "");

			// Aplica a máscara de telefone
			// phone = phone.replace(/^(\d{2})(\d)/g, "($1) $2");
			phone = phone.replace(/^(\d{2})(\d)/g, "($1)$2");
			phone = phone.replace(/(\d)(\d{4})$/, "$1-$2");

			return phone;
		} catch (error) {
			return "";
		}
	},
	cep: (cep) => {
		try {
			// Remove todos os caracteres não numéricos
			cep = cep.replace(/\D/g, "");

			// Aplica a máscara de CEP
			cep = cep.replace(/^(\d{5})(\d)/g, "$1-$2");

			return cep;
		} catch (error) {
			return "";
		}
	},
	onlynumbers: (number) => {
		try {
			return number.replace(/\D/g, "");
		} catch (error) {
			return number;
		}
	},
	//remove tudo que não for número e o prefixo 55
	onlyPhone: (number) => {
		try {
			const newNumber = number.replace(/\D/g, "");

			// 2. Remove o DDI (55)
			const numeroSemDDI = newNumber.startsWith("55") ? newNumber.slice(2) : newNumber;

			return numeroSemDDI;
		} catch (error) {
			return number;
		}
	},
	onlyCurrency: (value) => {
		try {
			value = value.replace(/[^\d,]|(?<=,.*),/g, "");

			return parseFloat(value);
		} catch (error) {
			return 0;
		}
	},
};

export default LibMask;
